import download from 'downloadjs';
import { ReportService } from '../reportService';

type reportFormat = 'Word' | 'PDF';
type reportType = 'UndercarriageInspection' | 'BucketInspection';
type reportResponseType = 'File' | 'Link';

interface DownloadInspectionReportProps {
  inspectionId: number;
  reportType?: reportType;
  responseType?: reportResponseType;
  exportFormats?: reportFormat[];
}

export default class InspectionReportService {
  static async downloadInspectionReport({
    inspectionId,
    reportType = 'UndercarriageInspection',
    responseType = 'File',
    exportFormats = ['Word'],
  }: DownloadInspectionReportProps): Promise<boolean> {
    const service = new ReportService();

    const response = await service.getReport({
      entityId: inspectionId,
      reportType: reportType,
      responseType: responseType,
      exportFormats: exportFormats,
    });

    if (response.success === false) {
      console.error(response.error);
      return false;
    }

    download(
      response.data,
      response.filename,
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    );

    return true;
  }
}
